import { compose, prop, isEmpty } from 'ramda'

export const invalid = compose(isEmpty, prop('email'))


// WEBPACK FOOTER //
// ./client/modules/user/components/SignIn/utils.js